import { render, staticRenderFns } from "./VariableNumber.vue?vue&type=template&id=54580b0c&scoped=true&"
import script from "./VariableNumber.vue?vue&type=script&lang=ts&"
export * from "./VariableNumber.vue?vue&type=script&lang=ts&"
import style0 from "./VariableNumber.vue?vue&type=style&index=0&id=54580b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54580b0c",
  null
  
)

export default component.exports